import { render, staticRenderFns } from "./CopyPackage.vue?vue&type=template&id=6c0207b6&"
import script from "./CopyPackage.vue?vue&type=script&lang=js&"
export * from "./CopyPackage.vue?vue&type=script&lang=js&"
import style0 from "./CopyPackage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports